import React, { useEffect, useState } from "react";
import "../Item/item.css";
import toast, { Toaster } from 'react-hot-toast';
import Button from 'react-bootstrap/Button';
import 'react-toastify/dist/ReactToastify.css';

const ItemCount = ({ initial, stock, onAdd, disabled }) => {
  const [count, setCount] = useState(parseInt(initial));

  useEffect(() => {
    setCount(parseInt(initial));
  }, [initial]);

  const decrease = () => {
    if (count > 1) setCount(count - 1);
  };

  const increase = () => {
    if (count < stock) setCount(count + 1);
  };

  const notify = () => {
    toast.success(`Se agregó ${count} ${count > 1 ? 'productos' : 'producto'} al pedido!`);
  };

  return (
    <div className="counter text-center">
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginBottom: '10px' }}>
        <Button variant="outline-secondary" size="sm" onClick={decrease} disabled={count <= 1}>–</Button>
        <span style={{ fontSize: '1.5rem', width: '40px' }}>{count}</span>
        <Button variant="outline-secondary" size="sm" onClick={increase} disabled={count >= stock}>+</Button>
      </div>

      <Button
        variant="primary"
        onClick={() => {
          notify();
          onAdd(count);
        }}
      >
        Agregar al pedido
      </Button>

      <Toaster position="bottom-right" reverseOrder={false} />
    </div>
  );
};

export default ItemCount;
